import { render, staticRenderFns } from "./nums.vue?vue&type=template&id=3f2fa06c&scoped=true"
import script from "./nums.vue?vue&type=script&lang=js"
export * from "./nums.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2fa06c",
  null
  
)

export default component.exports